export default __webpack_public_path__ + "static/media/spinner.6e07f9e1.svg";